import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";

import { LOADER_SCOPES } from "components/Loader/constants";
import Loader from "components/Loader/Loader";

class GlobalLoader extends React.Component {
    render() {
        const {siteLoader} = this.props;

        return (
            <Loader isLoading={siteLoader}/>
        );
    }
};

GlobalLoader.propTypes = {
    siteLoader: PropTypes.bool
};

GlobalLoader.defaultProps = {
    siteLoader: false
};

const mapStateToProps = (state) => {
    const { loaders } = state;
    return {
        siteLoader: loaders[`${LOADER_SCOPES.SITE}`],
    }
};

export default connect(
    mapStateToProps,
    null,
)(GlobalLoader);